import React, { useEffect, useState } from "react";

import { Card, Col, message, Row, Typography } from "antd";
import PropTypes from "prop-types";

import { getRefernEarnPartnerSalesAnalytics } from "../Pages/api";
import Loader from "../Utils/Loader";

const formatIndianNumber = (value) => {
  return new Intl.NumberFormat("en-IN").format(value);
};

const RefernEarnPartnerSalesAnalyticsExpand = ({ productId }) => {
  const [stats, setStats] = useState({
    totalSales: 0,
    totalCommission: 0,
    totalSaleValue: 0,
  });
  const [loading, setLoading] = useState(false);

  const handleGetRefernEarnPartnerProductsAnalytics = async () => {
    setLoading(true);
    try {
      const res = await getRefernEarnPartnerSalesAnalytics(productId);

      if (res?.code === 200) {
        setStats(res.result);
      } else {
        message.error("Something went wrong");
      }
    } catch (err) {
      console.log(err);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (productId) {
      handleGetRefernEarnPartnerProductsAnalytics();
    }
  }, [productId]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Row
          // gutter={[16, 16]}
          style={{
            width: "100%",
            gap: "16px",
          }}
        >
          <Col span={4}>
            <Card title="Total Sales Value" bordered={false}>
              <Typography>
                ₹{formatIndianNumber(stats?.totalSaleValue)}
              </Typography>
            </Card>
          </Col>
          <Col span={4}>
            <Card title="Total Sales" bordered={false}>
              <Typography>₹{formatIndianNumber(stats?.totalSales)}</Typography>
            </Card>
          </Col>
          <Col span={4}>
            <Card title="Total Commission" bordered={false}>
              <Typography>
                ₹{formatIndianNumber(stats?.totalCommission)}
              </Typography>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

RefernEarnPartnerSalesAnalyticsExpand.propTypes = {
  productId: PropTypes.string,
};

export default RefernEarnPartnerSalesAnalyticsExpand;
